import React, { useMemo } from "react";
import { useFormikContext } from "formik";
import { Row } from "common/components";
import { Button } from "components/bootstrap";
import { Spinner } from "components/common";
function FormButtons({ onCancel, creating }) {
  const { isValid, submitForm } = useFormikContext();
  const submitText = useMemo(() => creating ? "Creating..." : "Create Investigation", [creating]);
  return /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "flex-end" }, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, "Cancel"), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: submitForm, disabled: !isValid || creating }, /* @__PURE__ */ React.createElement(Row, { $align: "center" }, creating && /* @__PURE__ */ React.createElement(Spinner, { text: "" }), submitText)));
}
export default FormButtons;
